<script>
import PageLayout from '../components/js/Components/UI/PageLayout.vue'
import mixinComponent from '../components/js/Mixins/mixinComponent.js'
import { globalVariablesMixin } from '../components/js/Mixins/global.js'
import MainContainer from '../components/js/Components/UI/Content/MainContainer.vue'
import MainContent from '../components/js/Components/UI/Content/MainContent.vue'
import EntityMenu from '../components/js/Components/Entity/EntityMenu.vue'

export default {
  components: {
    EntityMenu,
    MainContainer,
    MainContent,
    PageLayout,
  },
  mixins: [mixinComponent, globalVariablesMixin],

  props: {
    id: {
      type: Number,
      required: true,
    },
  },

  computed: {
    entityName() {
      return this.$route.params.slug
    },
  },
}
</script>
<template>
  <PageLayout menu="societes-index">
    <MainContainer>
      <MainContent>
        <EntityMenu :entity-id="id" :entity-name="entityName" />

        <RouterView />
      </MainContent>
    </MainContainer>
  </PageLayout>
</template>
